<template>
    <div
        class="h-24 px-6 mb-3 rounded-md flex flex-row justify-between items-center "
        :class="
            course.is_unlocked
                ? 'bg-white hover:bg-primary-lightest hover:shadow-xl cursor-pointer'
                : 'bg-grey-lightest'
        "
        @click="
            () => {
                if (course.is_unlocked) $emit('click');
            }
        "
    >
        <div style="width: calc(100% - 80px)">
            <div
                class="w-full mb-3 font-semibold text-lg text-black whitespace-nowrap overflow-hidden overflow-ellipsis"
            >
                {{ course.name }}
            </div>
            <div
                class="w-full text-base text-grey whitespace-nowrap overflow-hidden overflow-ellipsis"
            >
                {{
                    course.is_unlocked
                        ? `${course.video_count} ${
                              course.video_count == 1 ? "Video" : "Videos"
                          } ${
                              course.location
                                  ? `- ${course.location.street} ${course.location.house_number}, ${course.location.city}`
                                  : ""
                          }`
                        : "Freischaltung am: " + course.activation_date
                }}
            </div>
        </div>
        <div>
            <progress-circle
                v-if="course.is_unlocked"
                :course_finished="course.total_progress.total"
            />
            <div v-else class="flex justify-center items-center w-18 h-18">
                <lock-closed-icon fillClass="fill-black" />
            </div>
        </div>
    </div>
</template>

<script>
import { defineComponent } from "@vue/runtime-core";
import ProgressCircle from "../../components/helper/ProgressCircle.vue";
import LockClosedIcon from "../../components/icons/LockClosedIcon.vue";

export default defineComponent({
    name: "CourseItem",
    components: { ProgressCircle, LockClosedIcon },
    emits: ["click"],
    props: {
        course: { required: true },
    },
});
</script>
